import { lunaMoonColors } from '../../../mocks/lunaMoonColors';

const topProducts = lunaMoonColors.slice(0, 10);

export default function TopProductsSection() {
  return (
    <section className="py-20 bg-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-serif font-bold text-center text-stone-900 mb-12">
          PRECIOS TOP
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
          {topProducts.map((product) => (
            <div key={product.id} className="group cursor-pointer">
              <div className="relative bg-stone-50 rounded-lg overflow-hidden mb-4 aspect-square">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <button className="absolute bottom-4 left-1/2 -translate-x-1/2 px-6 py-2 bg-stone-900 text-white text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                  Añadir al carrito
                </button>
              </div>
              <div className="text-center">
                <p className="text-xs text-stone-500 mb-1">Luna Moon</p>
                <p className="text-sm font-medium text-stone-900 mb-1">{product.name}</p>
                <p className="text-sm text-stone-700">{product.price}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <button className="px-8 py-3 border-2 border-stone-900 text-stone-900 font-medium text-sm hover:bg-stone-900 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
            Ver todos los productos
          </button>
        </div>
      </div>
    </section>
  );
}
